export default "__VITE_ASSET__CxL1pF$o__"